// ============================================
// ROLC OneROLC - Button Component
// Version: 3.6.0
// ============================================

import { createElement } from '../utils/domHelpers.js';

export const BUTTON_TYPES = {
    PRIMARY: 'btn-primary',
    SECONDARY: 'btn-secondary',
    SUCCESS: 'btn-success',
    DANGER: 'btn-danger',
    WARNING: 'btn-warning'
};

export function createButton(text, type = BUTTON_TYPES.PRIMARY, options = {}) {
    const {
        className = '',
        onClick = null,
        disabled = false,
        id = ''
    } = options;

    const classes = ['btn', type];
    if (className) classes.push(className);

    const attrs = { id };
    if (disabled) attrs.disabled = 'disabled';

    const button = createElement('button', classes.join(' '), text, attrs);

    if (onClick) {
        button.addEventListener('click', onClick);
    }

    return button;
}


